import React from "react";
var __jsx = React.createElement;
import { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { Drawer } from "vaul";
import WarrantyOptionItem from "./WarrantyOptionItem";
import { useTranslation } from "@i18n";
import { Icon } from "@syarahtech/ui";
import { twMerge } from "tailwind-merge";
export default function WarrantyBottomSheet(_ref) {
  var data = _ref.data,
    open = _ref.open,
    selectedId = _ref.selectedId,
    onSelect = _ref.onSelect,
    onClose = _ref.onClose,
    onConfirm = _ref.onConfirm;
  var _useTranslation = useTranslation(["web_checkout_cash"]),
    tShort = _useTranslation.tShort;
  // Internal staging state — only committed on confirm
  var _useState = useState(selectedId),
    stagingId = _useState[0],
    setStagingId = _useState[1];

  // Re-sync staging to the prop-selected id every time the sheet opens.
  // This ensures the API-selected option is always pre-highlighted on open.
  useEffect(function () {
    if (open) {
      setStagingId(selectedId);
    }
  }, [open, selectedId]);

  // Button is enabled only when the user has staged a DIFFERENT, non-default option.
  var stagingItem = data.items.find(function (i) {
    return i.id === stagingId;
  });
  var selectedItem = data.items.find(function (i) {
    return i.id === selectedId;
  });
  var isSameSelection = stagingId === selectedId;
  var isDefaultSelected = selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.is_default;
  var isConfirmEnabled = !isDefaultSelected || !isSameSelection;
  var handleConfirm = function handleConfirm() {
    onSelect(stagingId);
    onConfirm(stagingId);
  };
  var handleClose = function handleClose() {
    // Reset staging back to current confirmed selection on dismiss
    setStagingId(selectedId);
    onClose();
  };
  return /*#__PURE__*/React.createElement(Drawer.Root, {
    open: open,
    onOpenChange: function onOpenChange(o) {
      if (!o) handleClose();
    },
    snapPoints: [1],
    closeThreshold: 0.65
  }, /*#__PURE__*/React.createElement(Drawer.Portal, null, /*#__PURE__*/React.createElement(Drawer.Overlay, {
    className: "fixed inset-0 bg-[#071425]/50 opacity-50 z-[999998]"
  }), /*#__PURE__*/React.createElement(Drawer.Content, {
    className: "fixed bottom-0 left-0 right-0 z-[999999] bg-[#fbfbfb] rounded-t-[20px] flex flex-col outline-none"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex justify-center pt-3 pb-1"
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-[49px] h-[5px] rounded-full bg-[#020202]"
  })), /*#__PURE__*/React.createElement("div", {
    className: "px-4 py-2"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-end mb-1"
  }, /*#__PURE__*/React.createElement("div", {
    onClick: handleClose,
    className: "w-7 h-7 flex items-center justify-center text-[#09090B] hover:opacity-70 cursor-pointer transition-opacity"
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: "material-symbols--close",
    width: 4,
    height: 4
  }))), /*#__PURE__*/React.createElement(Drawer.Title, {
    className: "text-center font-bold text-[#020202] text-[16px] leading-6 mb-1"
  }, tShort("warranty/extend_title", {
    ns: "web_checkout_cash"
  })), /*#__PURE__*/React.createElement("p", {
    className: "text-center font-semibold text-[#979797] text-[12px] leading-5 pt-1 pb-2"
  }, tShort("warranty/extend_subtitle", {
    ns: "web_checkout_cash"
  }))), /*#__PURE__*/React.createElement(motion.div, {
    className: "px-4 py-4 space-y-3 overflow-y-auto max-h-[50vh]",
    initial: "hidden",
    animate: "visible",
    variants: {
      visible: {
        transition: {
          staggerChildren: 0.07,
          delayChildren: 0.05
        }
      },
      hidden: {}
    }
  }, data.items.map(function (item, itemIndex) {
    var stagingIndex = data.items.findIndex(function (i) {
      return i.id === stagingId;
    });
    return /*#__PURE__*/React.createElement(motion.div, {
      key: item.id,
      variants: {
        hidden: {
          opacity: 0,
          y: 14
        },
        visible: {
          opacity: 1,
          y: 0,
          transition: {
            duration: 0.3,
            ease: "easeOut"
          }
        }
      }
    }, /*#__PURE__*/React.createElement(WarrantyOptionItem, {
      item: item,
      isSelected: stagingId === item.id,
      onSelect: function onSelect(id) {
        return setStagingId(id);
      },
      size: "sm",
      showBadge: true,
      animateGlow: Boolean(item.badge) && stagingIndex < itemIndex
    }));
  })), /*#__PURE__*/React.createElement("div", {
    className: "px-4 pt-4 pb-8"
  }, /*#__PURE__*/React.createElement("button", {
    onClick: handleConfirm,
    disabled: !isConfirmEnabled,
    className: twMerge("border-none w-full rounded-lg py-3 text-white font-bold text-[16px] leading-6 transition-all", isConfirmEnabled ? "bg-primary-new  hover:bg-[#0a0a90] active:bg-[#08087a] cursor-pointer" : "bg-[#c0c0e0] cursor-not-allowed opacity-60")
  }, tShort("warranty/confirm", {
    ns: "web_checkout_cash"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-center pb-3"
  }, /*#__PURE__*/React.createElement("div", {
    className: "bg-[#020202] h-[4.5px] w-[127px] rounded-full"
  })))));
}